import data from "./retiredBlogRoutes.json";

export interface RetiredRoute {
  /** Retired blog path, e.g. "/blog/tennis-stats-glossary" */
  from: string;
  /** Surviving destination path */
  to: string;
}

/**
 * Thin blog URLs that were merged into stronger destinations.
 *
 * These are NOT HTTP 301 redirects: the hosting layer answers every URL with
 * HTTP 200, so each retired URL instead renders a short merged/moved page that
 * links to its destination, is marked `noindex, follow` in both the hydrated
 * and prerendered output, and is removed from the sitemap.
 */
export const RETIRED_BLOG_ROUTES: RetiredRoute[] = data.routes;

export const RETIRED_BLOG_SLUGS = RETIRED_BLOG_ROUTES.map((r) =>
  r.from.replace(/^\/blog\//, ""),
);

/** Destination path for a retired blog slug, or undefined when not retired. */
export function getRetiredDestination(slug: string | undefined): string | undefined {
  if (!slug) return undefined;
  return RETIRED_BLOG_ROUTES.find((r) => r.from === `/blog/${slug}`)?.to;
}

export function isRetiredBlogSlug(slug: string | undefined): boolean {
  return getRetiredDestination(slug) !== undefined;
}
